import * as React from "react";

import { Outlet, useNavigate } from "react-router-dom";

import { useConnectedUser } from "../../Context/ConnectedUserContext";

import Sidebar from "../../Components/Sidebar";
import TopBar from "../../Components/TopBar";

import "./Layout.scss";

const Layout = () => {
  const [isExpand, setIsExpand] = React.useState(true);

  const navigate = useNavigate();
  const { token } = useConnectedUser();

  React.useEffect(() => {
    if (!token) {
      navigate("/login");
    }
  }, [navigate, token]);

  const handleExpanded = () => {
    setIsExpand((prev) => !prev);
  };

  return token ? (
    <div className="layout-app">
      <Sidebar isExpandedBar={isExpand} onClickExpand={handleExpanded} />
      <div className="wrap-app">
        <TopBar />
        <div className="container-app">
          <Outlet />
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default Layout;
